import { DocumentTree, DocumentTreeV2, CollabDocumentTree, DocumentTreeDeliverables } from "./document-tree.objects";
import { plainToClass } from "class-transformer";


export class DocumentTreeLoader {

    documentTree: DocumentTree;

    constructor(nodes: any) {
        $(() => {

            this.documentTree = new DocumentTree(nodes);
        });
    }
}

export class DocumentTreeLoaderV2 {

    documentTree: DocumentTree;
    allNodes: DocumentNode[];
    treeId: string;
    searchBoxId: string;
    clearSearchId: string;

    dateFilterId: string;
    fileDisplayContainerId: string;

    constructor(nodes: any, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {

            this.treeId = treeId;
            this.searchBoxId = searchBoxId;
            this.clearSearchId = searchClearId;

            this.dateFilterId = `date-filter-${treeId}`;
            this.fileDisplayContainerId = `file-display-container-${treeId}`;

            this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);
            this.allNodes.forEach(node => node.initialize());

            if (targetFile != "" && targetFile != undefined && targetFile != null) {

                if (this.searchBoxId == targetSearchBox) {
                    let callbackFn = () => {
                        $(`#${this.searchBoxId}`).val(targetFile).trigger("keyup");
                    };

                    this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId, callbackFn);
                }
                else {
                    this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
                }
            }
            else {
                this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
            }

            this.initializeDateFilter();
            this.initializeCopyUrl();

        });
    }

    initializeCopyUrl(): void {
        // ensure no duplicate event listeners
        $("#copy-file-link-btn").off('click');

        $("#copy-file-link-btn").on('click', function () {
            let copyContent = $("#file-copy-id").val().toString();
            navigator.clipboard.writeText(copyContent);
        });

        $('#copy-file-link-btn').popover({
            trigger: 'focus'
        });
    }

    initializeDateFilter(): void {

        $(`#${this.dateFilterId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        $(`#${this.dateFilterId}`).on("changed.bs.select", () => {
            let selectedVal = $(`#${this.dateFilterId}`).val().toString();
            let parsedVal = parseInt(selectedVal);
            this.updateDocumentTreeByDate(parsedVal);
        })
    }

    updateDocumentTreeByDate(addDays: number = 0): void {
        // get nodes you want
        let currentNodes = this.allNodes;

        if (addDays != 0) {
            // Set the compare Date
            let currentDate = new Date();
            let compareDate = currentDate;
            compareDate.setTime(compareDate.getTime() - addDays * (24 * 60 * 60 * 1000)); // Converts days to milliseconds
            currentNodes = this.allNodes.filter(node => node.lastModifiedDate.getTime() >= compareDate.getTime() && node.type != 0);

            // Used to determine which folders to add, don't want folders without content
            let currentFolders = this.allNodes.filter(node => node.type == 0);
            let currentFolderNames = [];
            currentNodes.forEach(node => {
                let folderInRoot = false;
                if (node.parent != "#" && !currentFolderNames.includes(node.parent)) {
                    let parentSearch = node.parent;
                    while (folderInRoot == false) {
                        let foundFolder = currentFolders.find(folder => folder.id == parentSearch);
                        if (foundFolder != undefined) {
                            if (!currentFolderNames.includes(foundFolder.id)) {
                                currentFolderNames.push(foundFolder.id);
                                currentNodes.push(foundFolder);
                            }

                            if (foundFolder.parent == "#") {
                                folderInRoot = true; break;
                            }
                            else {
                                parentSearch = foundFolder.parent;
                            }
                        }
                        else {
                            break;
                        }
                    }

                }
            })
            // sort by id
            currentNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });
        }


        // clear current documents
        $(`#${this.fileDisplayContainerId}`).html(
            `<div id="${this.treeId}" class="jstree"></div>`
        );

        // create new document tree
        if (currentNodes.length > 0) {
            this.documentTree = new DocumentTreeV2(currentNodes, this.treeId, this.searchBoxId, this.clearSearchId);
        }
        else {
            $(`#${this.treeId}`).append(
                `<div class="p-2">No Documents Found</div>`
            )
        }

    }
}

export class DocumentTreeLoaderWithSharepoint {

    documentTree: DocumentTree;
    allNodes: DocumentNode[] = [];
    sharepointDocumentMap: DocumentNodeSharepointMapping = null;

    treeId: string;
    searchBoxId: string;
    clearSearchId: string;

    dateFilterId: string;
    fileDisplayContainerId: string;

    constructor(nodes: any, sharepointMapping: any, s3FolderPrefix: string, isCollab: boolean, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {
            this.treeId = treeId;
            this.searchBoxId = searchBoxId;
            this.clearSearchId = searchClearId;

            this.dateFilterId = `date-filter-${treeId}`;
            this.fileDisplayContainerId = `file-display-container-${treeId}`;
             
            if (sharepointMapping != "" && sharepointMapping != undefined && sharepointMapping != null) {
                this.sharepointDocumentMap = plainToClass(DocumentNodeSharepointMapping, <DocumentNodeSharepointMapping>sharepointMapping)
            }

            this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);

            // only show sharepoint links if the file tree is for collaborative editing
            this.allNodes.forEach(node => node.initialize(this.sharepointDocumentMap.files, isCollab));

            // Show Empty Folders from SP
            this.sharepointDocumentMap.folders.forEach(folder => folder.relativeFilePath = `${s3FolderPrefix}/${folder.relativeFilePath}`)
            let folderNodes = this.allNodes.filter(node => node.type == 0);
            let emptyFolders: DocumentNode[] = []
            this.sharepointDocumentMap.folders.forEach(folder => {
                // if the folder found in sharepoint is not found in the s3 bucket
                if (folderNodes.find(node => node.id == folder.relativeFilePath) == undefined) {
                    let nodeDate = new Date(0, 0, 0); // Jan 1, 1900
                    let nodeState = new DocumentNodeState();
                    nodeState.disabled = false;
                    nodeState.opened = false;
                    nodeState.selected = false;

                    let newFolderNode = new DocumentNode();
                    newFolderNode.id = folder.relativeFilePath;
                    newFolderNode.icon = "fas fa-folder empty-folder";
                    newFolderNode.link = "";
                    newFolderNode.type = 0;
                    newFolderNode.lastModified = nodeDate.toUTCString();
                    newFolderNode.lastModifiedDate = nodeDate;
                    newFolderNode.state = nodeState;

                    let filePathArray = folder.relativeFilePath.split("/");
                    let nodeText = filePathArray.pop();

                    let parentSearchString = filePathArray.join("/");
                    let nodeParent: string;
                    if (parentSearchString == s3FolderPrefix) {
                        nodeParent = "#"
                    }
                    else {
                        nodeParent = parentSearchString;
                    }
                    newFolderNode.parent = nodeParent;
                    newFolderNode.text = `${nodeText} - <span class='font-italic'>No Files</span>`;

                    emptyFolders.push(newFolderNode);
                }
            })
            this.allNodes.push(...emptyFolders);

            // sort by id
            this.allNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });

            // Handle target file is passed in
            if (targetFile != "" && targetFile != undefined && targetFile != null) {

                // Check that the search box passed in matches this search box
                if (targetSearchBox == this.searchBoxId) {
                    let callbackFn = () => {
                        $(`#${this.searchBoxId}`).val(targetFile).trigger("keyup");
                    };

                    this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId, callbackFn);
                }
                else {
                    this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
                }

                
            }
            else {
                this.documentTree = new DocumentTreeV2(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
            }

            this.initializeDateFilter();
            this.initializeCopyUrl();

        });
    }

    initializeCopyUrl(): void {
        // ensure no duplicate event listeners
        $("#copy-file-link-btn").off('click');

        $("#copy-file-link-btn").on('click', function () {
            let copyContent = $("#file-copy-id").val().toString();
            navigator.clipboard.writeText(copyContent);
        });

        $('#copy-file-link-btn').popover({
            trigger: 'focus'
        });
    }

    initializeDateFilter(): void {

        $(`#${this.dateFilterId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        $(`#${this.dateFilterId}`).on("changed.bs.select", () => {
            let selectedVal = $(`#${this.dateFilterId}`).val().toString();
            let parsedVal = parseInt(selectedVal);
            this.updateDocumentTreeByDate(parsedVal);
        })
    }

    updateDocumentTreeByDate(addDays: number = 0): void {
        // get nodes you want
        let currentNodes = this.allNodes;

        if (addDays != 0) {
            // Set the compare Date
            let currentDate = new Date();
            let compareDate = currentDate;
            compareDate.setTime(compareDate.getTime() - addDays * (24 * 60 * 60 * 1000)); // Converts days to milliseconds
            currentNodes = this.allNodes.filter(node => node.lastModifiedDate.getTime() >= compareDate.getTime() && node.type != 0);

            // Used to determine which folders to add, don't want folders without content
            let currentFolders = this.allNodes.filter(node => node.type == 0);
            let currentFolderNames = [];
            currentNodes.forEach(node => {
                let folderInRoot = false;
                if (node.parent != "#" && !currentFolderNames.includes(node.parent)) {
                    let parentSearch = node.parent;
                    while (folderInRoot == false) {
                        let foundFolder = currentFolders.find(folder => folder.id == parentSearch);
                        if (foundFolder != undefined) {
                            if (!currentFolderNames.includes(foundFolder.id)) {
                                currentFolderNames.push(foundFolder.id);
                                currentNodes.push(foundFolder);
                            }

                            if (foundFolder.parent == "#") {
                                folderInRoot = true; break;
                            }
                            else {
                                parentSearch = foundFolder.parent;
                            }
                        }
                        else {
                            break;
                        }
                    }

                }
            })
            // sort by id
            currentNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });
        }


        // clear current documents
        $(`#${this.fileDisplayContainerId}`).html(
            `<div id="${this.treeId}" class="jstree"></div>`
        );

        // create new document tree
        if (currentNodes.length > 0) {
            this.documentTree = new DocumentTreeV2(currentNodes, this.treeId, this.searchBoxId, this.clearSearchId);
        }
        else {
            $(`#${this.treeId}`).append(
                `<div class="p-2">No Documents Found</div>`
            )
        }

    }
}

export class DocumentTreeLoaderCollaborative {

    documentTree: DocumentTree;
    allNodes: DocumentNode[] = [];

    treeId: string;
    searchBoxId: string;
    clearSearchId: string;

    dateFilterId: string;
    fileDisplayContainerId: string;

    constructor(nodes: any, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {
            this.treeId = treeId;
            this.searchBoxId = searchBoxId;
            this.clearSearchId = searchClearId;

            this.dateFilterId = `date-filter-${treeId}`;
            this.fileDisplayContainerId = `file-display-container-${treeId}`;

            this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);
            this.allNodes.forEach(node => node.initialize());

            // sort by id
            this.allNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });

            // Handle target file is passed in
            if (targetFile != "" && targetFile != undefined && targetFile != null) {
                // Check that the search box passed in matches this search box
                if (targetSearchBox == this.searchBoxId) {
                    let callbackFn = () => {
                        $(`#${this.searchBoxId}`).val(targetFile).trigger("keyup");
                    };

                    this.documentTree = new CollabDocumentTree(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId, callbackFn);
                }
                else {
                    this.documentTree = new CollabDocumentTree(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
                }
            }
            else {
                this.documentTree = new CollabDocumentTree(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId);
            }

            this.initializeDateFilter();
            this.initializeCopyUrl();

        });
    }

    initializeCopyUrl(): void {
        // ensure no duplicate event listeners
        $("#copy-file-link-btn").off('click');

        $("#copy-file-link-btn").on('click', function () {
            let copyContent = $("#file-copy-id").val().toString();
            navigator.clipboard.writeText(copyContent);
        });

        $('#copy-file-link-btn').popover({
            trigger: 'focus'
        });
    }

    initializeDateFilter(): void {

        $(`#${this.dateFilterId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        $(`#${this.dateFilterId}`).on("changed.bs.select", () => {
            let selectedVal = $(`#${this.dateFilterId}`).val().toString();
            let parsedVal = parseInt(selectedVal);
            this.updateDocumentTreeByDate(parsedVal);
        })
    }

    updateDocumentTreeByDate(addDays: number = 0): void {
        // get nodes you want
        let currentNodes = this.allNodes;

        if (addDays != 0) {
            // Set the compare Date
            let currentDate = new Date();
            let compareDate = currentDate;
            compareDate.setTime(compareDate.getTime() - addDays * (24 * 60 * 60 * 1000)); // Converts days to milliseconds
            currentNodes = this.allNodes.filter(node => node.lastModifiedDate.getTime() >= compareDate.getTime() && node.type != 0);

            // Used to determine which folders to add, don't want folders without content
            let currentFolders = this.allNodes.filter(node => node.type == 0);
            let currentFolderNames = [];
            currentNodes.forEach(node => {
                let folderInRoot = false;
                if (node.parent != "#" && !currentFolderNames.includes(node.parent)) {
                    let parentSearch = node.parent;
                    while (folderInRoot == false) {
                        let foundFolder = currentFolders.find(folder => folder.id == parentSearch);
                        if (foundFolder != undefined) {
                            if (!currentFolderNames.includes(foundFolder.id)) {
                                currentFolderNames.push(foundFolder.id);
                                currentNodes.push(foundFolder);
                            }

                            if (foundFolder.parent == "#") {
                                folderInRoot = true; break;
                            }
                            else {
                                parentSearch = foundFolder.parent;
                            }
                        }
                        else {
                            break;
                        }
                    }

                }
            })
            // sort by id
            currentNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });
        }


        // clear current documents
        $(`#${this.fileDisplayContainerId}`).html(
            `<div id="${this.treeId}" class="jstree"></div>`
        );

        // create new document tree
        if (currentNodes.length > 0) {
            this.documentTree = new CollabDocumentTree(currentNodes, this.treeId, this.searchBoxId, this.clearSearchId);
        }
        else {
            $(`#${this.treeId}`).append(
                `<div class="p-2">No Documents Found</div>`
            )
        }

    }
}

export class DocumentTreeLoaderDeliverables {

    documentTree: DocumentTreeDeliverables;
    allNodes: DocumentNode[];
    treeId: string;
    searchBoxId: string;
    clearSearchId: string;
    iframeId: string;
    tabId: string;

    dateFilterId: string;
    fileDisplayContainerId: string;

    constructor(nodes: any, treeId: string = "jstree", searchBoxId: string = "docSearch", searchClearId: string = "searchClear", iframeId: string = "deliverable-attachment-tab-content", tabId: string = "deliverable-attachment-tab") {
        $(() => {

            this.treeId = treeId;
            this.searchBoxId = searchBoxId;
            this.clearSearchId = searchClearId;
            this.iframeId = iframeId;
            this.tabId = tabId;

            this.dateFilterId = `date-filter-${treeId}`;
            this.fileDisplayContainerId = `file-display-container-${treeId}`;

            this.allNodes = plainToClass(DocumentNode, <DocumentNode[]>nodes);
            this.allNodes.forEach(node => node.initialize());

            if (this.allNodes.length > 0) {
                this.documentTree = new DocumentTreeDeliverables(this.allNodes, this.treeId, this.searchBoxId, this.clearSearchId, this.iframeId, this.tabId);
            }
            else {
                $(`#${this.treeId}`).empty().append(
                    `<div class="p-2">No Attachments Found</div>`
                )
            }   

            this.initializeDateFilter();

        });
    }

    initializeDateFilter(): void {

        $(`#${this.dateFilterId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count"
        });

        $(`#${this.dateFilterId}`).on("changed.bs.select", () => {
            let selectedVal = $(`#${this.dateFilterId}`).val().toString();
            let parsedVal = parseInt(selectedVal);
            this.updateDocumentTreeByDate(parsedVal);
        })
    }

    updateDocumentTreeByDate(addDays: number = 0): void {
        // get nodes you want
        let currentNodes = this.allNodes;

        if (addDays != 0) {
            // Set the compare Date
            let currentDate = new Date();
            let compareDate = currentDate;
            compareDate.setTime(compareDate.getTime() - addDays * (24 * 60 * 60 * 1000)); // Converts days to milliseconds
            currentNodes = this.allNodes.filter(node => node.lastModifiedDate.getTime() >= compareDate.getTime() && node.type != 0);

            // Used to determine which folders to add, don't want folders without content
            let currentFolders = this.allNodes.filter(node => node.type == 0);
            let currentFolderNames = [];
            currentNodes.forEach(node => {
                let folderInRoot = false;
                if (node.parent != "#" && !currentFolderNames.includes(node.parent)) {
                    let parentSearch = node.parent;
                    while (folderInRoot == false) {
                        let foundFolder = currentFolders.find(folder => folder.id == parentSearch);
                        if (foundFolder != undefined) {
                            if (!currentFolderNames.includes(foundFolder.id)) {
                                currentFolderNames.push(foundFolder.id);
                                currentNodes.push(foundFolder);
                            }

                            if (foundFolder.parent == "#") {
                                folderInRoot = true; break;
                            }
                            else {
                                parentSearch = foundFolder.parent;
                            }
                        }
                        else {
                            break;
                        }
                    }

                }
            })
            // sort by id
            currentNodes.sort((x1, x2) => {
                // folders come first
                if (x1.type == 0 && x2.type != 0) {
                    return -1;
                }
                else if (x1.type != 0 && x2.type == 0) {
                    return 1;
                }
                return x1.id.localeCompare(x2.id)
            });
        }


        // clear current documents
        $(`#${this.fileDisplayContainerId}`).html(
            `<div id="${this.treeId}" class="jstree"></div>`
        );

        // create new document tree
        if (currentNodes.length > 0) {
            this.documentTree = new DocumentTreeDeliverables(currentNodes, this.treeId, this.searchBoxId, this.clearSearchId, this.iframeId, this.tabId);
        }
        else {
            $(`#${this.treeId}`).append(
                `<div class="p-2">No Attachments Found</div>`
            )
        }

    }
}

export class DocumentNode {
    icon: string;
    id: string;
    lastModified: string;
    link: string;
    parent: string;
    state: DocumentNodeState;
    text: string;
    type: number;

    lastModifiedDate: Date;
    spLink: string = "";
    displaySpLink: boolean = false;

    initialize(sharepointMapping: SharepointMappingFile[] = [], isCollab: boolean = false): void {
        this.lastModifiedDate = new Date(this.lastModified);

        // only pdfs and office documents can be opened in sharepoint
        if ([1, 2, 3, 4].includes(this.type)) {
            let searchId = this.id
            let foundSPItem = sharepointMapping.find(item => searchId.endsWith(item.relativeFilePath));
            if (foundSPItem != undefined) {
                if (isCollab) {
                    this.spLink = foundSPItem.spLink;
                    this.displaySpLink = true;
                }
                if (foundSPItem.lastModified != null && foundSPItem.lastModified != "" && foundSPItem != undefined) {
                    this.lastModifiedDate = new Date(foundSPItem.lastModified);
                }
            }
        }
    }

    initializeMerged(): void {
        this.lastModifiedDate = new Date(this.lastModified);
        if (this.link?.includes("sharepoint.com")) {
            this.spLink = this.link;
            this.displaySpLink = true;
        }
    }
}

class DocumentNodeState {
    disabled: boolean;
    opened: boolean;
    selected: boolean;
}

class DocumentNodeSharepointMapping {
    files: SharepointMappingFile[];
    folders: SharepointMappingFolder[];
}

class SharepointMappingFile {
    relativeFilePath: string;
    spLink: string;
    lastModified: string;
}

class SharepointMappingFolder {
    relativeFilePath: string;
}